"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipPosition = exports.createTagModal = void 0;
var react_1 = __importDefault(require("react"));
var DisplayedTags_1 = __importDefault(require("Dashboard/ProjectListItem/DisplayedTags/DisplayedTags"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontendBackend/Project/Types");
var HTTP_MESSAGES_1 = require("@CommonFrontendBackend/Utils/HTTP_MESSAGES");
var TagModal = (function (_super) {
    __extends(TagModal, _super);
    function TagModal(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTags = function () {
            var allTags = _this.allTags;
            if (allTags.length) {
                return allTags.map(_this.renderTag);
            }
            else {
                return react_1.default.createElement("p", { className: "tag-modal-inner__enter-message" }, "Press enter to create new tag");
            }
        };
        _this.handleKeyPress = function (event) {
            var pressAddTagKey = event.key === "Enter" || event.key === "Tab";
            var tagNotNull = _this.searchTerm;
            if (!pressAddTagKey || !tagNotNull)
                return;
            var validTagLength = _this.searchTerm.length > 0 && _this.searchTerm.length <= Types_1.MAX_TAG_LENGTH;
            if (!validTagLength) {
                _this.errorMessage = HTTP_MESSAGES_1.ERROR_TAG_LENGTH;
                return;
            }
            _this.projectTagDataStore.createTag(_this.searchTerm);
            _this.projectStores.forEach(function (projectStore) {
                projectStore.addTag(_this.searchTerm);
            });
            _this.searchTerm = undefined;
        };
        _this.onTagClick = function (tag) {
            _this.projectStores.forEach(function (projectStore) {
                (0, mobx_1.runInAction)(function () {
                    projectStore.addTag(tag);
                });
            });
        };
        _this.onCrossClick = function (tag, event) {
            event.stopPropagation();
            _this.projectStores.forEach(function (projectStore) {
                (0, mobx_1.runInAction)(function () {
                    projectStore.removeTag(tag);
                });
            });
        };
        _this.renderTag = function (tag) {
            return (react_1.default.createElement("div", { className: "tag-modal-inner__tag", key: tag, onClick: function () { return _this.onTagClick(tag); } },
                react_1.default.createElement("div", { className: "tag-modal-inner__tag-name" }, tag),
                _this.tags.includes(tag) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(icons_1.Tick, { className: "tag-modal-inner__tick" }),
                    react_1.default.createElement("div", { className: "tag-modal-inner__remove-tag" },
                        react_1.default.createElement(kaleidoscope_2.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: function (event) { return _this.onCrossClick(tag, event); }, size: kaleidoscope_2.ButtonSize.Small, tooltip: {
                                content: "Remove tag",
                                position: (0, exports.getTooltipPosition)(_this.allTags.length, _this.allTags.indexOf(tag)),
                            } }))))));
        };
        _this.projectStores = props.projectStores;
        _this.projectTagDataStore = props.projectTagDataStore;
        return _this;
    }
    TagModal.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "tag-modal-inner" },
            react_1.default.createElement("div", { className: "tag-modal-inner__displayed-tags" },
                react_1.default.createElement(DisplayedTags_1.default, { tags: this.tags })),
            react_1.default.createElement("div", { className: "tag-modal-inner__search", onKeyDown: this.handleKeyPress },
                react_1.default.createElement(kaleidoscope_2.SearchInput, { label: "Find or create a tag", placeholder: "Type to search or create a tag", value: this.searchTerm, onChange: this.onSearchChange, onClear: this.onSearchClear, error: this.errorMessage })),
            react_1.default.createElement("div", { className: "tag-modal-inner__tags" }, this.renderTags())));
    };
    Object.defineProperty(TagModal.prototype, "tags", {
        get: function () {
            var tagsOfEachProjectStore = this.projectStores.map(function (projectStore) {
                return projectStore.tags;
            });
            return lodash_1.intersection.apply(void 0, __spreadArray([], __read(tagsOfEachProjectStore), false));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagModal.prototype, "allTags", {
        get: function () {
            if (!this.searchTerm) {
                return this.projectTagDataStore.projectTags;
            }
            else {
                var searchTerm_1 = this.searchTerm.toLowerCase();
                return this.projectTagDataStore.projectTags.filter(function (tag) {
                    return tag.toLowerCase().includes(searchTerm_1);
                });
            }
        },
        enumerable: false,
        configurable: true
    });
    TagModal.prototype.onSearchChange = function (searchTerm) {
        this.searchTerm = searchTerm;
    };
    TagModal.prototype.onSearchClear = function () {
        this.searchTerm = "";
        this.errorMessage = "";
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], TagModal.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], TagModal.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TagModal.prototype, "handleKeyPress", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], TagModal.prototype, "tags", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], TagModal.prototype, "allTags", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TagModal.prototype, "onSearchChange", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TagModal.prototype, "onSearchClear", null);
    TagModal = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TagModal);
    return TagModal;
}(react_1.default.Component));
exports.default = TagModal;
var createTagModal = function (projectStores, projectTagDataStore) {
    return react_1.default.createElement(TagModal, { projectStores: projectStores, projectTagDataStore: projectTagDataStore });
};
exports.createTagModal = createTagModal;
var getTooltipPosition = function (numTags, currentTagIndex) {
    if (numTags > 5 && currentTagIndex === numTags - 1) {
        return kaleidoscope_1.TooltipPosition.Top;
    }
    else {
        return kaleidoscope_1.TooltipPosition.Bottom;
    }
};
exports.getTooltipPosition = getTooltipPosition;
